// extracted by mini-css-extract-plugin
export default {"layout":"GamblingSessionLimitsPopup__layout--9Oy","container":"GamblingSessionLimitsPopup__container--27t"};